/**
 * Method to trim leading zeroes from an integer or number in string.
 * For example, if the number is '00123', then the returned number is '123'.
 * @param   number in 'string' or 'number' type.
 * @returns number in 'string' after the leading zeroes are removed.
 */
export const trimLeadingZeroes = (number) => {
  return number.toString().replace(/^0+/, '');
};

/**
 * Method to add a comma '.' every 3 digits from the least significant digit.
 * For example, if number is '3000000', then the returned value is '3.000.000'.
 * @param   number in 'string' or 'number' type.
 * @returns number in 'string' with commas '.'.
 */
const addDotSeparatorToNumber = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

/**
 * Method to return formatted price with 'IDR' as the currency.
 * @param price in 'string' or 'number' type.
 * @returns string formatted string with prefix `IDR ` as the currency.
 */
export const getFormattedPriceTag = (price) => {
  return `IDR ${addDotSeparatorToNumber(price)}`;
};
